import { WarningAlert } from '../shared/icons/WarningAlert'
import { Banner } from './Banner'

type WarningProps = {
  title: string
  children: string
  handleClose?(): void
}

const Warning = (props: WarningProps) => {
  const { title, children, handleClose } = props
  return <Banner
    title={title}
    handleClose={handleClose}
    textColor="#433900"
    borderColor='#F7C800'
    backgroundColor='#FEF8F2'
    flag={<WarningAlert />}
  >
    {children}
  </Banner>
}

export { Warning }
